import { createFileRoute } from '@tanstack/react-router';
import NoMemberPage from 'src/features/plugins/outlook/(auth)/(setup)/no-member/page';

export const Route = createFileRoute('/plugins/outlook/_outlookAuth/_outlookSetup/no-member')({
  component: NoMemberPage,
});
